/**
 *
 * @prettier
 */
var AbstractViewModel = require("./AbstractViewModel");
var ConsumerSearchWS = require("../ws/ConsumerSearchWS");
var CustomFieldsWS = require("../ws/CustomFieldsWS");

function SearchViewModel(parent) {
    var self = this;

    // Predicate this ViewModel on the Abstract class of a View Model
    // This tacks on additional functionality, including the ability to
    // read URL query parameters, and an observable binding predicated
    // on another object's observable-bound variables
    AbstractViewModel.apply(this, [parent]);

    self.customFieldsWS = new CustomFieldsWS(parent);
    self.consumerSearchWS = new ConsumerSearchWS(parent);

    self.searched = ko.observable(false);
    self.searchFor = ko.observable(null);
    self.searchForFocused = ko.observable(false);
    self.selectedOption = ko.observable(null);
    self.nameOrPhoneField = {
        name: "nameOrPhone",
        label: "Name or Last 4 Digits",
    };

    self.searchOptions = ko.computed(function () {
        return new Array(self.nameOrPhoneField).concat(
            self.customFieldsWS.customFields()
        );
    });

    self.searchOptions.subscribe(function (option) {
        self.selectedOption(option[0]);
    });

    /**
     * Resets the component to it's default state
     *
     * @method reset
     * @returns none
     */
    self.reset = function () {
        self.searched(false);
        self.searchFor(null);
        self.searchForFocused(false);
        self.consumerSearchWS.clearParams();
        self.consumerSearchWS.spots.removeAll();
    };

    /**
     * Invokes the doRequest method to request data from the API
     *
     * @method search
     * @returns none
     */
    self.search = function () {
        var queueIds = self.parent.queueIds();
        var isSearchByCustomProp = ( self.selectedOption().name !== self.nameOrPhoneField.name );

        if (self.canSearch() && queueIds.length > 0) {
            if (isSearchByCustomProp) {
                self.consumerSearchWS.searchByCustomProp(queueIds, this.selectedOption().name, self.searchFor(), self.afterSearch)
            } else {
                self.consumerSearchWS.searchWaiting(queueIds, self.searchFor(), self.afterSearch)
            }
        }
    };

    /**
     * Determines if the search can be performed
     * must have at least 3 chars
     *
     * @method canSearch
     * @returns {Boolean}
     */
    self.canSearch = ko.computed(function () {
        return (
            self.searchFor() &&
            self.searchFor().length >= self.MIN_FILTER_LENGTH
        );
    });

    /**
     * @description Callback function to be called after doRequest finishes
     * @method afterSearch
     * @returns void
     */
    self.afterSearch = function () {
        self.searched(true);
    };

    /**
     * Method to capture the enter key in the UI and invoke the
     * search, for convenience
     *
     * @method checkForEnter
     * @param {Object} data
     * @param {KeyboardEvent} evt
     * @returns {Boolean} true
     */
    self.checkForEnter = function (data, evt) {
        self.searched(false);

        // If it was the enter key, perform the search
        if (evt.keyCode == 13) {
            self.search();
        }

        return true;
    };

    /**
     * Returns whether any of the selected locations have a usePartySize config
     *
     * @method includePartySize
     * @returns {Boolean}
     */
    self.includePartySize = ko.computed(function () {
        var locs = self.parent.selectedLocations();
        if (locs && locs.length > 0) {
            return locs.filter(function (loc) {
                return loc.usePartySize == true;
            });
        }
        return false;
    });

	/**
	 * Method to locate the queue the selected user is located in, scroll it into
	 * view, and select the Consumer (showing the detail)
	 *
	 * @method focusConsumer
	 * @param {Object} data
	 * @param {MouseEvent} evt
	 * @returns {Boolean} true
	 */
    self.focusConsumer = function (data, evt) {
        var queueId = data.queueId;

        if (self.parent.selectedQueueIds.indexOf(queueId) === -1) {
            self.parent.queueSelectionVM.addQueueId(queueId);
        }

        self.parent.showConsumerDetail(data, null);
        self.parent.searchHide();

        return true;
    };

}

SearchViewModel.prototype.MIN_FILTER_LENGTH = 3;

module.exports = SearchViewModel;
